import React, { ReactElement } from 'react';
import { Content } from './Content';

interface RegisterEmailPageProps {}

function RegisterEmailPage({}: RegisterEmailPageProps): ReactElement {
  return <Content />;
}

export { RegisterEmailPage };
